import { render, staticRenderFns } from "./AddAdvance.vue?vue&type=template&id=3ba66111"
import script from "./AddAdvance.vue?vue&type=script&lang=js"
export * from "./AddAdvance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports